function ScrapWarning() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label="스크랩 경고"
    >
      <desc>스크랩 경고</desc>
      <g data-name="그룹 4320" transform="translate(-528 -740)">
        <circle
          cx="12"
          cy="12"
          r="12"
          fill="#ccc"
          data-name="타원 702"
          transform="translate(528 740)"
        ></circle>
        <g fill="#fff" data-name="그룹 4300">
          <path d="M539 747h2v6h-2z" data-name="사각형 4846"></path>
          <path d="M539 755h2v2h-2z" data-name="사각형 4847"></path>
        </g>
      </g>
    </svg>
  )
}

export default ScrapWarning
